const s = "af.filter-sidebar.language-filter-toggled", e = class e extends CustomEvent {
  constructor(a) {
    super(s, { detail: { language: a }, bubbles: !0, composed: !0 });
  }
};
e.EVENT_NAME = s;
let t = e;
export {
  s as EVENT_NAME,
  t as default
};
//# sourceMappingURL=LanguageFilterToggleEvent.js.map
